import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';

import { IBgamingGameList, IBgamingLaunchResponse } from '../../types/interfaces/Slots/Bgaming';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IGetGameUrl } from '../../types/slot';
import { getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IBgamingGameList>): ISlotViewItem[] => {
    const games = data.data;

    return games.map(game => ({
      id: game.identifier,
      gameId: game.identifier,
      type: CasinoType.slots,
      description: game.title,
      routeProvider: 'bgaming',
      gameName: game.title,
      provider: 'bgaming',
      tab: getTab(game.identifier.toString()),
      imageUrl: `https://cdn.softswiss.net/i/s3/softswiss/${game.identifier}.webp`,
      isLiveGame: false,
    }));
  };

  convertGameUrl = ({ data }: IGetGameUrl<IBgamingLaunchResponse, null>) => data.launch_options.game_url;
}
export default Converter;
